<template>
    <el-tooltip :disabled="!tooltipContent"
                effect="dark"
                :content="tooltipContent"
                :placement="tooltipPosition">
        <el-button class="x-button-icon"
                   :class="{'x-button-icon-small': isSmall, 'x-button-icon-with-text': text !== ''}"
                   :disabled="disabled"
                   :type="type"
                   @click="$emit('click')"
                   v-loading="loading">
            <i :class="icon"></i>
            <div class="text" v-if="text !== ''" v-text="text"></div>
        </el-button>
    </el-tooltip>
</template>

<script>

export default {
    name: 'XButtonIcon',
    props: {
        icon: {
            type: String,
        },
        isSmall: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        tooltipContent: {
            type: String,
            default: null
        },
        tooltipPosition: {
            type: String,
            default: 'bottom'
        },
        type: {
            type: String,
            default: 'primary'
        },
        text: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {}
    },
}
</script>
